import { Slider } from './Slider';
import withFormField from '../../utils/form/withFormField';

export default withFormField(Slider);
